'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Dropdown = require('./Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  children: _react.PropTypes.node
};

var ButtonDropdown = function ButtonDropdown(props) {
  return _react2.default.createElement(_Dropdown2.default, _extends({}, props, { group: true }));
};

ButtonDropdown.propTypes = propTypes;

exports.default = ButtonDropdown;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactstrap/lib/ButtonDropdown.js
 ** module id = 1149
 ** module chunks = 0
 **/